import { createUseStyles } from "react-jss";
import { colors } from "../../../constants/colors";
import { breakpoints } from "../../../constants/breakpoints";

const styles = createUseStyles(theme => ({
  mainDiv: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  bodyContainer: {
    width: "70vw",
    marginTop: "32px",
    [`@media (max-width: ${breakpoints.lg}px)`]: {
      width: "100%",
      padding: "0px 60px",
    },
    [`@media (max-width: ${breakpoints.md}px)`]: {
      width: "100%",
      padding: "0px 20px",
    },
  },
  title: {
    fontSize: "30px",
    fontWeight: "600",
    lineHeight: "38px",
    color: colors.lightBlack,
    marginBottom: "12px",
  },
  secondaryText1: {
    fontSize: "16px",
    fontWeight: "400",
    lineHeight: "24px",
    color: colors.inactiveGrey,
    marginBottom:"20px"
  },
  secondaryText2: {
    extend: "secondaryText1",
    color: colors.mediumGrey,
    marginBottom:"20px"
  },
  stepTitle: {
    fontSize: "20px",
    fontWeight: "500",
    lineHeight: "30px",
    color: colors.lightBlack,
    marginBottom: "8px"
  },
  divider: {
    width: "100%",
    color: colors.lightGrey,
    opacity: 2
  },
  secondStepContainer: {
    marginTop: "32px"
  },
  firstStepContainer: {
    marginTop: "32px"
  },
  importBtn:{
    fontSize: "14px",
    fontWeight: "600",
    lineHeight: "20px",
    padding: "8px 14px 8px 14px",
    width: "fit-content",
    marginBottom: "20px",
    "& svg":{
      marginLeft: "6px"
    },
  },
  listItem: {
    fontSize: "18px",
    fontWeight: "600",
    lineHeight: "24px",
    color: colors.mediumGrey,
    marginBottom:"8px"
  },
  list: {
    "& li":{
      "& .marker":{
        marginTop:"15px"
      }
    }
  },
  downloadBtnLoadingState: {
    backgroundColor: `${colors.white} !important`,
    border: theme.buttons.default.border,
    "& span": {
      borderColor: `${colors.grey} ${colors.grey} transparent !important`
    }
  }
}));

export default styles;
